import * as React from "react";

import i18next from "i18next";

import Dropdown from "../Dropdown";
import { Nav } from "./styles";
import { DeleteIcon } from "../../svg";

const DeletionNavItem = ({ isVisible }: { isVisible: boolean }) => {
  if (!isVisible) {
    return null;
  }

  const deletion = [
    {
      label: i18next.t("delete_sku_mapping"),
      to: "/sku-mapping-deletion",
    },
    {
      label: i18next.t("delete_rows_from_sales_table"),
      to: "/row-from-sales-table-deletion",
    },
    {
      label: i18next.t("delete_dtr_sales"),
      to: "/dtr-sales-deletion",
    },
  ];

  return (
    <Nav.Item>
      <Dropdown
        icon={DeleteIcon}
        title={i18next.t("deletion")}
        items={deletion}
      />
    </Nav.Item>
  );
};

export default DeletionNavItem;
